export const API_CONFIG = {
  BASE_URL: 'https://westbengalexam.mystudyplace.online/backend/',

  ENDPOINTS: {
    USERDATA: 'UserData.php',
    LOGINUPDATE: 'LoginUpdate.php',
    SIGNUP: 'SignUp.php',
    PUSHDATA: 'PushData.php',
    UPDATEPROFILE: 'UpdateProfile.php',
    DELETEACCOUNT: 'DeleteAccount.php',
    USERBEFORELOGIN: 'UserBeforeLogin.php',
    APPINSTALLPUSH: 'AppInstallPush.php',
    APPITEMSUSEPUSH: 'AppItemsUsePush.php',


  }
};

